<template>
  <div id="app">
    <router-view />
    <el-backtop :bottom="30">
      <div class="backtop"><i class="el-icon-top icon"></i></div>
    </el-backtop>
  </div>
</template>

<script>
export default {
  mounted() {
    window.addEventListener('beforeDestory', () => {
      sessionStorage.clear()
    })
  },
  methods: {
    changeActive(e) {
      console.log(e)
      e.currentTarget.className = 'active'
      console.log('鼠标移入了')
    },
    removeActive(e) {
      e.currentTarget.className = ''
      console.log('鼠标移出了')
    }
  }
}
</script>

<style>


@import 'assets/css/style.css';
@import 'assets/css/fontcss.css';



#app {
  height: 100vh;
}


</style>




